import { QuestionAnswer } from '../types/Question'

type Answer = string | string[] | undefined | null

// Single-select answers are stored as one answer id, multi-select (checkbox) answers as a list of ids.
export const normalizeAnswerIds = (answer: Answer): string[] => {
    if (Array.isArray(answer)) return answer.map(String)
    if (answer === undefined || answer === null) return []
    return [String(answer)]
}

// Order-insensitive exact match: a multi-select answer is correct only when it selects exactly the
// trainer's set. Mirrors answers_match in LITTWebBackendLambda's controller.py.
export const answersMatch = (learnerAnswer: Answer, trainerAnswer: Answer): boolean => {
    const learnerIds = normalizeAnswerIds(learnerAnswer).sort()
    const trainerIds = normalizeAnswerIds(trainerAnswer).sort()
    return learnerIds.length === trainerIds.length && learnerIds.every((id, i) => id === trainerIds[i])
}

// Labels of the selected answers in template order, or '-' when nothing matches.
export const answerToLabel = (answer: Answer, questionAnswers: QuestionAnswer[] = []): string => {
    const ids = normalizeAnswerIds(answer)
    const labels = questionAnswers
        .filter((a) => ids.includes(String(a.answerId)))
        .map((a) => a.answerLabel)
    return labels.length > 0 ? labels.join(', ') : '-'
}
